define([
	"dojo/_base/declare",
	"csi/action/EditController",
	"csi/heading/AttributeEdit"
], function(declare,EditController,AttributeEdit) {
	
	return declare(EditController, {
		constructor: function(/*Object*/params) {
			// summary: replace attribute edit action with Edit row action in case it applies extra logic/configuration;
			// NOTE: this will be too late if action has AccessAction or Rules - in that case, make Heading read-only so that user must
			// click on Edit row action rather than edit through tooltip
			if (this.m_action instanceof AttributeEdit) {
				var	qr = this.widget.getQueryResultByDomNode(this.refNode);
				var	a = qr.level.actions && qr.level.actions.getAction("Edit");
				if (a) {
					this.m_action = a;
				}
			}
		}
	});
});